import { render, staticRenderFns } from "./SitchFileUpload.vue?vue&type=template&id=68c4d087&scoped=true&"
import script from "./SitchFileUpload.vue?vue&type=script&lang=ts&"
export * from "./SitchFileUpload.vue?vue&type=script&lang=ts&"
import style0 from "./SitchFileUpload.vue?vue&type=style&index=0&id=68c4d087&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c4d087",
  null
  
)

export default component.exports